window.addEventListener('load', function() {
  let announcementBarClose = document.querySelector('.dwpb-action');
  setTimeout(function() {
    if (document.body.classList.contains('dwpb-open')) {
      announcementBarClose.click();
    }
    }, 6000
  );
});



// WEBPACK FOOTER //
// ./src/js/components/announcementbar.js